import { render, staticRenderFns } from "./events-completed.vue?vue&type=template&id=91070e1c&scoped=true&"
import script from "./events-completed.vue?vue&type=script&lang=js&"
export * from "./events-completed.vue?vue&type=script&lang=js&"
import style0 from "./events-completed.vue?vue&type=style&index=0&id=91070e1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91070e1c",
  null
  
)

/* custom blocks */
import block0 from "./events-completed.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports